import KitchenSink from './KitchenSink'

export default KitchenSink
// eslint-disable-next-line import/export
export * from './KitchenSink'
